/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";

export type SetToolVariationsGroupRequestBody = {
  /**
   * The tool variations group id to assign, or null to disable filtering.
   */
  toolVariationsGroupId?: string | undefined;
};

/** @internal */
export type SetToolVariationsGroupRequestBody$Outbound = {
  tool_variations_group_id?: string | undefined;
};

/** @internal */
export const SetToolVariationsGroupRequestBody$outboundSchema: z.ZodMiniType<
  SetToolVariationsGroupRequestBody$Outbound,
  SetToolVariationsGroupRequestBody
> = z.pipe(
  z.object({
    toolVariationsGroupId: z.optional(z.string()),
  }),
  z.transform((v) => {
    return remap$(v, {
      toolVariationsGroupId: "tool_variations_group_id",
    });
  }),
);

export function setToolVariationsGroupRequestBodyToJSON(
  setToolVariationsGroupRequestBody: SetToolVariationsGroupRequestBody,
): string {
  return JSON.stringify(
    SetToolVariationsGroupRequestBody$outboundSchema.parse(
      setToolVariationsGroupRequestBody,
    ),
  );
}
